import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Punkt odbioru',
  type: 'object',
  properties: {
    id: {
      type: 'number',
      title: 'idendtyfikator wniosku',
      fieldRequired: true
    },
    completed: {
      title: 'Wniosek został złożony kompletnie',
      type: 'boolean',
      computed: true,
      fieldRequired: 'this.state === "ACCEPTED"'
    },
    qualified: {
      title: 'Mieszkaniec posiada uprawnienia do korzystania z UKM',
      type: 'boolean',
      computed: true,
      fieldRequired: 'this.state === "ACCEPTED"'
    },
    state: {
      title: 'Status',
      type: 'string',
      fieldRequired: true
    },
    reason: {
      title: 'Uzasadnienie',
      type: 'string',
      fieldRequired: '!this.qualified'
    },
    groups: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          groupId: {
            type: 'number'
          },
          accepted: {
            type: 'boolean'
          },
          reason: {
            title: 'Powód',
            type: 'string',
            fieldRequired: '!this.accepted'
          },
          title: {
            type: 'string',
            computed: true
          }
        }
      }
    }
  }
};
